// extracted by mini-css-extract-plugin
export var text = "_8m-0";